import { render, staticRenderFns } from "./ProveedorFormulario.vue?vue&type=template&id=12ee8744&scoped=true"
import script from "./ProveedorFormulario.vue?vue&type=script&lang=js"
export * from "./ProveedorFormulario.vue?vue&type=script&lang=js"
import style0 from "./ProveedorFormulario.vue?vue&type=style&index=0&id=12ee8744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee8744",
  null
  
)

export default component.exports